<template>
  <sui-page>
    <!-- Page Header -->
    <sui-page-header :pageId="this.$options.name" />
    <!-- Page Contents -->
    <sui-page-contents>
      <!-- Contents - Search Bar -->
      <div class="comm_title_wrap">
        <h4>{{ $t("MSG_TXT_STD_FORM_NM") }} : {{ documentName }}  ({{ pageInitialData.standardFormId }})</h4>
      </div>
      <sui-grid
        ref="grid"
        :columns="gridColumns0"
        :dataset="'dsStandardForm'"
        :autoheight="false"
        :showDisplayCountControl="false"
      />
    </sui-page-contents>
    <sui-page-footer>
      <div class="comm_btn_wrap">
        <sui-button
          type="button"
          class="comm_btn_solid"
          @click="onClickClose"
        >
          {{ $t("MSG_BTN_CLOSE") }}
        </sui-button>
      </div>
    </sui-page-footer>
  </sui-page>
</template>
<script>
// eslint-disable-next-line import/no-unresolved
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMD_00008', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    closePagePopup: {
      type: Function,
      default() {
        return null;
      },
    },
    pageInitialData: {
      type: Object,
      default() {
        return null;
      },
    },
  },
  data() {
    return {
      selectedCodeValue: {
        COD_MDLE: {
          label: '',
          key: '',
        },
      },
      documentName: '',
      localdata0: [],
      gridColumns0: [{
        text: this.$t('MSG_TXT_LANG_DIV'),
        datafield: 'langId',
        width: '100px',
        rowspan: this.rowSpan,
        cellClassName: 'line_R',
      }, {
        text: this.$t('MSG_TXT_FILE_NM'),
        datafield: 'fileName',
        // width: '200px',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellFileDnButton(row, column, value, htmlElement, {
            type: 'link', // 'link', 'sublink' 둘 중 하나 지정, default 값은 'link'
            pageId: this.$options.name,
          }, this.dsStandardForm, this.$refs.grid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_NOTE'),
        datafield: 'attachItemContent',
      }],
    };
  },
  datasets: [{
    id: 'dsStandardForm',
    type: 'local',
    data: 'localdata0',
    datafields: [
      { name: 'rowType', type: 'string', map: 'rowType' },
      { name: 'count', type: 'int', map: 'count' },
      { name: 'checkBox', type: 'string', map: 'checkBox' },
      { name: 'langId', type: 'string', map: 'langId' },
      { name: 'attachItemName', type: 'string', map: 'attachItemName' },
      { name: 'fileName', type: 'string', map: 'fileName' },
      { name: 'fileSize', type: 'string', map: 'fileSize' },
      { name: 'attachItemContent', type: 'string', map: 'attachItemContent' },
      { name: 'attachDocumentId', type: 'string', map: 'attachDocumentId' },
      { name: 'documentName', type: 'string', map: 'documentName' },
      { name: 'documentFileSN', type: 'int', map: 'documentFileSN' }],
  }],
  mounted() {
    this.$nextTick(() => {
      this.selectDataFormInput();
    });
  },
  methods: {
    onClickClose() {
      this.closePagePopup('');
    },
    selectDataFormInput() {
      http.request(this.$options.name, 'DTS_CMD_00005', {
        path: {
          'standard-form-id': this.pageInitialData.standardFormId,
        },
      }).then(res => {
        this.dsStandardForm.setRawData(res.data); // 데이터 셋에 데이터를 넣는 함수
        this.documentName = res.data[0].documentName; // 데이터 셋에 데이터를 넣는 함수
      });
    },
    rowSpan(row, col, value) {
      const topLangId = row > 0 ? this.dsStandardForm.data[row - 1].langId : '';

      if (!utils.isEqual(topLangId, value)) {
        return this.dsStandardForm.data[row].count;
      }
      return 1;
    },
  },
};
</script>
<style scoped>
</style>
